import { INTEGRATION_CODE } from "../../../../../models/IntegrationsTypes";
import { makeAutoObservable } from "mobx";
import { ICredentialsStore } from "../integration-store";
import IntegratorOAuthHandler from "./oauth-handler/integrator-oauth-handler";

export interface IGorgiasAppCredentials {
    subdomain: string,
}

class GorgiasAppCredentialsStore implements ICredentialsStore {
    private _changes: IGorgiasAppCredentials = {} as IGorgiasAppCredentials;
    private _oauthHandler = new IntegratorOAuthHandler(INTEGRATION_CODE.GORGIAS_APP);
    
    constructor() {
        makeAutoObservable(this);
    }

    public get subdomain() { return this._changes.subdomain; }
    public set subdomain(v: string) { this._changes.subdomain = v; }

    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as IGorgiasAppCredentials;
    }

    getCredentials() {
        return this._oauthHandler.getCredentials(this._changes);
    }


}

export default GorgiasAppCredentialsStore;
